import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { BirthdaysScreen } from '@/features/hr-reports/birthdays-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/birthdays')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: BirthdaysScreenRoute,
})

function BirthdaysScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <BirthdaysScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/birthdays', search: next })}
    />
  )
}
